export default "__VITE_ASSET__BE2Bx_zS__"